/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

/** Values shared by publication list filter forms (URL-backed). */
export type PublicationListFilterFormValues = {
  search?: string
  tags: string[]
  myPublications?: boolean
  needsReview?: boolean
  sortBy?: string
}

/** Build filter form values from route-resolved search params. */
export function publicationListFilterFormValuesFromResolvedParams(params: {
  search?: string
  tags?: string[]
  sortBy?: string
  myPublications: boolean
  needsReview: boolean
}): PublicationListFilterFormValues {
  return {
    search: params.search ?? '',
    tags: params.tags ?? [],
    myPublications: params.myPublications,
    needsReview: params.needsReview,
    sortBy: params.sortBy,
  }
}
